const listImageTag = document.querySelectorAll('.slide-img-bg > img');

const listImage = Array.from(listImageTag).map((item) => {
  return item.getAttribute('src');
});

let counter = 0;

const slideshowWithFadeIn = () => {
  if (counter < listImage.length - 1) {
    counter++;
  } else {
    counter = 0;
  }

  document.getElementsByClassName('slide-img')[0].style.backgroundImage = 'url(' + listImage[counter] + ')';
};

setInterval(slideshowWithFadeIn, 5000);
